"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/identity.js
// module id = 386
// module chunks = 0